import './signature/action.document.signature';

angular
  .module('doxy.realtime.components.teleconsent.action.document', [
    'doxy.realtime.components.teleconsent.action.document.signature',
  ])
  .directive('tcLabel', function ($compile) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true, // prevent lower priority directives to compile after it
      compile: function (tElement, tAttrs) {
        var suffix;
        tElement.removeAttr('tc-label');
        var i = tAttrs.tcLabel.indexOf('[');
        if (i !== -1) {
          suffix =
            tAttrs.tcLabel.substr(0, i) +
            '.options' +
            tAttrs.tcLabel.substr(i) +
            '.description';
        } else {
          suffix = tAttrs.tcLabel + '.description';
        }

        tElement.attr({
          'bs-tooltip': '',
          'data-title': '{{document.metadata.fields.' + suffix + '}}',
        });
        return function (scope) {
          return $compile(tElement)(scope);
        };
      },
    };
  })
  .directive('tcInputText', function ($compile) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true, // prevent lower priority directives to compile after it
      compile: function (tElement, tAttrs) {
        tElement.removeAttr('tc-input-text');
        return function (scope) {
          var name = tAttrs.ngModel.split('.').pop();

          var editBy = 'document.metadata.fields.' + name + '.editBy';
          var disabled = 'document.metadata.fields.' + name + '.disabled';
          tElement.attr({
            placeholder:
              '{{document.metadata.fields.' + name + '.placeholder}}',
            'ng-required': !!(
              scope.document && scope.document.metadata.fields[name].validate
            ),
            'ng-disabled':
              '!me || ' +
              editBy +
              ' && ' +
              editBy +
              ' !== me.type' +
              ' || ' +
              disabled,
          });
          return $compile(tElement)(scope);
        };
      },
    };
  })
  .directive('tcInputCheckbox', function ($compile) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true, // prevent lower priority directives to compile after it
      compile: function (tElement, tAttrs) {
        tElement.removeAttr('tc-input-checkbox');
        return function (scope) {
          var name = tAttrs.ngModel.split('.').pop();
          var editBy = 'document.metadata.fields.' + name + '.editBy';
          var disabled = 'document.metadata.fields.' + name + '.disabled';
          tElement.attr({
            'ng-required': !!(
              scope.document && scope.document.metadata.fields[name].validate
            ),
            'ng-disabled':
              '!me || ' +
              editBy +
              ' && ' +
              editBy +
              ' !== me.type || ' +
              disabled,
          });
          return $compile(tElement)(scope);
        };
      },
    };
  })
  .directive('tcInputRadio', function ($compile) {
    return {
      restrict: 'A',
      priority: 1001,
      terminal: true, // prevent lower priority directives to compile after it
      compile: function (tElement, tAttrs) {
        tElement.removeAttr('tc-input-radio');
        return function (scope) {
          var name = tAttrs.ngModel.split('.').pop();
          var editBy = 'document.metadata.fields.' + name + '.editBy';
          var disabled = 'document.metadata.fields.' + name + '.disabled';
          tElement.attr({
            'ng-required': !!(
              scope.document && scope.document.metadata.fields[name].validate
            ),
            'ng-disabled':
              '!me || ' +
              editBy +
              ' && ' +
              editBy +
              ' !== me.type || ' +
              disabled,
          });
          return $compile(tElement)(scope);
        };
      },
    };
  });
